export default (password: string): boolean => {
  const regex = new RegExp(
    /^((?=.*[\d])(?=.*[a-z])(?=.*[A-Z])(?=.*[a-z])(?=.*[A-Z])(?=.*[^\w\d\s])(?=.*[\d])(?=.*[A-Z])(?=.*[^\w\d\s])(?=.*[\d])(?=.*[a-z])(?=.*[^\w\d\s])).{10,30}$/gm
  )

  return regex.test(password)
}
